import {
    ArcType,
    Cartesian2,
    Cartesian3,
    Color,
    GeometryInstance,
    Material,
    PolylineGeometry,
    PolylineMaterialAppearance,
    Primitive,
    requestAnimationFrame,
} from 'cesium';
import { transformGeometry } from '../feature-layer/createFeatureCollection';

export default class LineFlowLayer extends Primitive {
    constructor(option) {
        const {
            fadeOutColor,
            fadeInColor,
            width = 4.0,
            data,
            fadeOutOpacity = 1,
            fadeInOpacity = 1,
            speed = 0.005,
            id: key,
            name,
            labelField,
            template,
            legend,
            show = true,
            map,
            layerControl = true,
        } = option;

        const instances = data.map(item => {
            let geometry = item.geometry;
            if (item.geometryInfo) {
                geometry = transformGeometry(item.geometryInfo)
            }
            const polyline = new PolylineGeometry({
                positions: Cartesian3.fromDegreesArray(geometry.coordinates.flat(Infinity)),
                width,
                arcType: ArcType.GEODESIC,
            });
            return new GeometryInstance({
                geometry: polyline,
                values_: item,
                id: item.id,
            });
        });

        const appearance = new PolylineMaterialAppearance({
            material: Material.fromType(Material.FadeType, {
                repeat: true,
                fadeInColor: Color.fromCssColorString(
                    fadeInColor || 'rgb(255, 255, 255)',
                ).withAlpha(fadeInOpacity),
                fadeOutColor: Color.fromCssColorString(
                    fadeOutColor || 'rgb(16, 129, 255)',
                ).withAlpha(fadeOutOpacity),
                time: new Cartesian2(0, 0),
                maximumDistance: 0.15 / 2.5,
                fadeDirection: {
                    x: true,
                    y: false,
                },
            }),
        });

        const primitive = new Primitive({
            geometryInstances: instances,
            compressVertices: false,
            show: true,
            appearance: appearance,
            depthFailAppearance: appearance,
        });
        let timex = 0;
        function render() {
            timex += speed; // 控制流动速度
            if (timex >= 1) {
                timex = 0; // 控制在0.0到1.0之间
            }

            primitive.appearance.material.uniforms.time.x = timex;
            requestAnimationFrame(render);
        }
        requestAnimationFrame(render);
        super(primitive);
        super.show = show;

        // 图层标识
        this.key = key;

        // 图层名称
        this.name = name;

        // 标签字段
        this.labelField = labelField;

        // 模版内容
        this.template = template;

        this.data = data;
        // 图例
        this.legend = legend;
        this.layerControl = layerControl;
        // 地图
        this.map = map;
    }

    // 根据条件获取图形数据
    getFeatureByFieldValue(field, value) {
        return this.getFeatures().find(v => v[field] === value);
    }

    // 获取图形
    getFeatures() {
        return this.data;
    }

    // 重写父类的属性访问器
    get show() {
        return super.show;
    }

    set show(value) {
        this.setVisible(value);
    }

    // 设置图层显示隐藏
    setVisible(visible) {
        super.show = visible; // 将属性传递给父类

        const map = this.getMap && this.getMap();
        if (map) {
            map.layers.emit('visible', this, visible);
        }
    }

    // 获取地图
    getMap() {
        return this.map;
    }
}
